export { setGoogleFonts, addGlobalFont, removeGlobalFont, replaceGlobalFonts, setGoogleFontsVariants } from './utils/fonts';
export { setUploadFunc } from './side-panel/upload-panel';
export { setFontUploadFunc } from './side-panel/text-panel';
export { toggleFadeInAnimation } from './canvas/use-fadein';
export { setHighlighterStyle } from './canvas/highlighter';
export { setTransformerStyle } from './canvas/page';
export { setInnerImageCropTransformerStyle } from './canvas/image-element';
export { setOuterImageCropTransformerStyle } from './canvas/image-element';
export { setImageLoaderHook as unstable_setImageLoaderHook } from './canvas/image-element';
export { registerShapeModel as unstable_registerShapeModel } from './model/group-model';
export { registerShapeComponent as unstable_registerShapeComponent } from './canvas/element';
export { registerTransformerAttrs as unstable_registerTransformerAttrs } from './canvas/page';
export { registerToolbarComponent as unstable_registerToolbarComponent } from './toolbar/toolbar';
export { onLoadError, setAssetLoadTimeout, setFontLoadTimeout } from './utils/loader';
export { setSnapFilterFunc as unstable_setSnapFilterFunc } from './canvas/use-transformer-snap';
export { setTranslations, getTranslations } from './utils/l10n';
export { registerNextDomDrop as unstable_registerNextDomDrop } from './canvas/page';
export { getGoogleFontsListAPI, getGoogleFontImage, setAPI } from './utils/api';
export { setColorsPresetFunc } from './toolbar/color-picker';
export { setQuillFormats as unstable_setQuillFormats } from './canvas/html-element';
export { useDownScaling } from './utils/flags';
export { useRemoveBackground as unstable_setRemoveBackgroundEnabled } from './utils/flags';
export { useHtmlTextRender as unstable_useHtmlTextRender } from './utils/flags';
export { setForceTextFit as unstable_setForceTextFit } from './utils/flags';
export { setTextSplitAllowed as unstable_setTextSplitAllowed } from './utils/flags';
export { setTextOverflow as unstable_setTextOverflow } from './utils/flags';
export { setTextVerticalResizeEnabled as unstable_setTextVerticalResizeEnabled } from './utils/flags';
export { setAnimationsEnabled as unstable_setAnimationsEnabled } from './utils/flags';
